import View from './View'
import { TweenMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'

class WebflowView extends View {

  constructor(id) {
    super(id)
    this.webflowDataAttr = 'webflow'
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    const list = [...container.querySelectorAll('*[data-webflow]')]
    list.forEach(this.showElement.bind(this))
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    const list = [...container.querySelectorAll('*[data-webflow]')]
    list.forEach(this.hideElement.bind(this))
  }

  /**
   * Show element
   * @param {DOM} el 
   * @param {int} index 
   */
  showElement(el, index) {
    const props = this.getWebflowProps(el)
    if (props.show) {
      TweenMax.from(el, props.show.time, props.show.tween)
    }
  }
  /**
   * Hide element
   * @param {DOM} el 
   * @param {int} index 
   */
  hideElement(el, index) {
    const props = this.getWebflowProps(el)
    if (props.hide) {
      TweenMax.to(el, props.hide.time, props.hide.tween)
    }
  }
  /**
   * get the webflow props from element's dataset
   * @param {DOM} el 
   * @return {*}
   */
  getWebflowProps(el) {
    let params = {}
    if (el) {
      const str = el.dataset[this.webflowDataAttr]
      if (str) {
        const groups = str.split(';')
        params.show = this.getWebflowAnimationProps(groups[0])
        params.hide = groups.length > 1 ? this.getWebflowAnimationProps(groups[1]) : params.show
      }
      
    }
    return params
  }
  /**
   * group string to JS object
   * @param {string} gstr (eg. y:100,o:0)
   * @return {*}
   */
  getWebflowAnimationProps(gstr) {
    let propsFromData = {}
    const arr = gstr.split(',')
    arr.forEach((s, index) => {
      let p = this.parseWebflowKeyValue(s)
      propsFromData = {...propsFromData, ...p}
    })
    return this.getValidWebflowAnimationProps(propsFromData)
  }
  /**
   * divide properties for TweenMax use: time (int) vs tween (obj)
   * @param {*} propsFromData 
   * @return {*}
   */
  getValidWebflowAnimationProps(propsFromData) {
    let ap = {
      time: 800,
      tween: {}
    }
    for (let key in propsFromData) {
      switch (key) {
        case 'time':
          ap.time = propsFromData[key]
          break;
        default:
          ap.tween[key] = propsFromData[key]
          break;
      }
    }
    return ap
  }
  /**
   * key:value string to JS object
   * @param {string} s (eg. y:100)
   * @return {*}
   */
  parseWebflowKeyValue(s) {
    let p = {}
    const arr = s.split(':')
    if (arr.length > 1) {
      const key = this.translateKey(arr[0])
      const val = isNaN(arr[1]) ? this.translateNonNumericValue(key, arr[1]) : parseFloat(arr[1])
      p[key] = val
    }
    return p
  }
  /**
   * Translate key (eg: 'o' = 'opacity')
   * @param {string} keyStr 
   * @return string
   */
  translateKey(keyStr) {
    let key = ''
    switch (keyStr) {
      case 'd':
        key = 'delay'
        break
      case 'e':
        key = 'ease'
        break
      case 'h':
        key = 'height'
        break
      case 'o':
        key = 'opacity'
        break
      case 'r':
        key = 'rotation'
        break
      case 't':
        key = 'time'
        break
      case 'w':
        key = 'width'
        break
      default:
        key = keyStr
        break
    }
    return key
  }
  /**
   * Translate non numeric value strings... 
   * @param {string} key 
   * @param {string} valStr 
   * @return {*}
   */
  translateNonNumericValue(key, valStr) {
    let val
    switch (key) {
      case 'ease':
        val = this.getWebflowEasing(valStr)
        break;
      default:
        // by default don't change anything (eg. '100%', '50vw')
        val = valStr
        break;
    }
    return val
  }
  /**
   * Get the TweenMax Easing function
   * @param {string} str 
   * @return {Ease}
   */
  getWebflowEasing(str) {
    let easing
    let arr = str.split('.')
    if (arr.length == 2) {
      switch (arr[0]) {
        case 'Back':
          easing = Back[arr[1]]
          break;
        case 'Bounce':
          easing = Bounce[arr[1]]
          break;
        case 'Circ':
          easing = Circ[arr[1]]
          break;
        case 'Elastic':
          easing = Elastic[arr[1]]
          break;
        case 'Expo':
          easing = Expo[arr[1]]
          break;
        case 'Power0':
          easing = Power0[arr[1]]
          break;
        case 'Power1':
          easing = Power1[arr[1]]
          break;
        case 'Power2':
          easing = Power2[arr[1]]
          break;
        case 'Power3':
          easing = Power3[arr[1]]
          break;
        case 'Power4':
          easing = Power4[arr[1]]
          break;
        case 'SlowMo':
          easing = SlowMo[arr[1]]
          break;
        case 'Stepped':
          easing = SteppedEase[arr[1]]
          break;
        default:
          easing = Sine[arr[1]]
          break;
      }
    }
    return easing
  }

}

export default WebflowView